import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconMove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M2.5 15h15v-1.667h-15V15zm0-4.167h15V9.167h-15v1.666zM2.5 5v1.667h15V5h-15z"
	})
});
export default SvgIconMove;
